<form class="discounts"  [formGroup]="this.couponFb" *ngIf="this.cart">
    <div class="formularyCoupon display-utils-row display-utils-between-center display-utils-gap-8">
        <mat-form-field class="display-utils-flex-1" appearance="outline">
            <mat-label>Código do cupom</mat-label>
            <input matInput
            matInput #couponIdentifier
            [(ngModel)]="this.cart.couponIdentifier"
            formControlName="couponIdentifier"
            (input)="formatCoupon()">
            <mat-icon *ngIf="this.cart.hasValidAppliedCoupon" matPrefix>check_circle</mat-icon>
        </mat-form-field>

        <button mat-stroked-button color="primary" 
        *ngIf="!this.submittingCouponCode"
        (click)="this.isAplicarButton ? removeCoupon() : applyCoupon()">
        {{this.isAplicarButton ? "Remover" : "Aplicar" }}
        </button>
    </div>
    <mat-error *ngIf="this.couponIsInvalid" class="errorMessage">Cupom inserido é inválido</mat-error>
</form>